import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './Button.css';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Affiche un indicateur d'activite et desactive le bouton. */
  busy?: boolean;
  children: ReactNode;
}

/**
 * Bouton de base de l'interface.
 * Toujours un vrai `<button>` : navigation clavier, role et etat desactive
 * geres nativement par le navigateur.
 */
export function Button({
  variant = 'primary',
  size = 'md',
  busy = false,
  disabled,
  className,
  children,
  ...rest
}: ButtonProps) {
  const classes = ['fg-button', `fg-button--${variant}`, `fg-button--${size}`];
  if (busy) classes.push('fg-button--busy');
  if (className) classes.push(className);

  return (
    <button
      type="button"
      className={classes.join(' ')}
      disabled={disabled === true || busy}
      aria-busy={busy || undefined}
      {...rest}
    >
      {children}
    </button>
  );
}
